import { render, staticRenderFns } from "./ChooseObjectives.vue?vue&type=template&id=40c3f468&scoped=true"
import script from "./ChooseObjectives.vue?vue&type=script&lang=js"
export * from "./ChooseObjectives.vue?vue&type=script&lang=js"
import style0 from "./ChooseObjectives.vue?vue&type=style&index=0&id=40c3f468&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c3f468",
  null
  
)

export default component.exports